var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 5.75C9.20507 5.75 7.75 7.20507 7.75 9C7.75 10.7949 9.20507 12.25 11 12.25C12.7949 12.25 14.25 10.7949 14.25 9C14.25 7.20507 12.7949 5.75 11 5.75ZM6.25 9C6.25 6.37665 8.37665 4.25 11 4.25C13.6234 4.25 15.75 6.37665 15.75 9C15.75 11.6234 13.6234 13.75 11 13.75C8.37665 13.75 6.25 11.6234 6.25 9Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 16.3497C13.0795 16.3497 15.2139 17.0111 16.7143 18.4043C17.0931 18.756 17.4224 19.1677 17.6709 19.6646C17.8561 20.0351 17.7059 20.4856 17.3355 20.6708C16.965 20.8561 16.5145 20.7059 16.3292 20.3354C16.1722 20.0214 15.9599 19.7506 15.6937 19.5035C14.5316 18.4245 12.7933 17.8497 11 17.8497C9.20682 17.8497 7.46845 18.4245 6.30638 19.5035C6.0402 19.7506 5.82789 20.0214 5.67086 20.3354C5.48562 20.7059 5.03512 20.8561 4.66463 20.6708C4.29415 20.4856 4.14398 20.0351 4.32922 19.6646C4.57764 19.1677 4.90696 18.756 5.28574 18.4043C6.78623 17.0111 8.92056 16.3497 11 16.3497Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9669 7.02875C16.2424 7.63532 16.3882 8.303 16.3882 9C16.3882 9.697 16.2424 10.3647 15.9669 10.9712C16.2837 11.15 16.6465 11.25 17.0345 11.25C18.2492 11.25 19.25 10.2519 19.25 9C19.25 7.74814 18.2492 6.75 17.0345 6.75C16.6465 6.75 16.2837 6.84996 15.9669 7.02875ZM14.4802 6.281C15.1471 5.63971 16.0445 5.25 17.0345 5.25C19.0931 5.25 20.75 6.93528 20.75 9C20.75 11.0647 19.0931 12.75 17.0345 12.75C16.0445 12.75 15.1471 12.3603 14.4802 11.719C14.2205 11.4694 14.1751 11.0704 14.3718 10.7687C14.7042 10.259 14.8882 9.65548 14.8882 9C14.8882 8.34452 14.7042 7.74096 14.3718 7.23129C14.1751 6.9296 14.2205 6.53065 14.4802 6.281Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.70f244a6.svg";
export { ForwardRef as ReactComponent };